import { banco } from '../db/banco'
import { agoraISO } from '../db/tipos'
import type { Cliente, MotivoInativacao } from '../db/tipos'
import { gravarLocalEEnfileirar } from '../sync/outbox'

export const MOTIVOS_INATIVACAO: ReadonlyArray<MotivoInativacao> = [
  'mal_pagador', 'fechou', 'faliu', 'mudou_ramo', 'outro',
]

export const ROTULO_MOTIVO_INATIVACAO: Record<MotivoInativacao, string> = {
  mal_pagador: 'Mal pagador',
  fechou: 'Fechou as portas',
  faliu: 'Faliu',
  mudou_ramo: 'Mudou de ramo',
  outro: 'Outro',
}

// "Sem rota" e problema de ESQUECIMENTO, nao de decisao: o inativo nao aparece
// em agenda nenhuma de proposito. Incluir inativo aqui faria a faixa nunca
// chegar a zero, e alerta que nunca zera vira alerta que se aprende a ignorar.
//
// Comparacao com null explicita, e nao `!cliente.dia_visita`: domingo e 0, e 0 e
// falsy -- todo cliente de domingo cairia na lista para sempre.
export function semRota(cliente: Cliente): boolean {
  return cliente.apagado_em === null && cliente.status === 'ativo' && cliente.dia_visita === null
}

export function contarSemRota(clientes: Cliente[]): number {
  return clientes.filter(semRota).length
}

export async function inativarCliente(
  clienteId: string,
  motivo: MotivoInativacao,
  observacao: string | null,
): Promise<void> {
  const cliente = await banco.clientes.get(clienteId)
  if (!cliente) return
  await gravarLocalEEnfileirar('clientes', {
    ...cliente,
    status: 'inativo',
    motivo_inativacao: motivo,
    obs_inativacao: observacao,
    inativado_em: agoraISO(),
    atualizado_em: agoraISO(),
  })
}

// Reativar NAO limpa motivo/observacao/data: sao o historico que ela pediu --
// "se por esquecimento ele atender o cliente cadastrado por mal pagador, ter o
// historico e poder tomar a decisao".
export async function reativarCliente(clienteId: string): Promise<void> {
  const cliente = await banco.clientes.get(clienteId)
  if (!cliente) return
  await gravarLocalEEnfileirar('clientes', {
    ...cliente,
    status: 'ativo',
    atualizado_em: agoraISO(),
  })
}

// O que a ficha do cliente oferece. Mora aqui, e nao dentro do FormCliente,
// porque a regra tem uma armadilha que ja passou batido no plano: inativar NAO
// depende de o cliente estar sem rota. O botao tinha nascido dentro da tarja
// ambar de "sem rota", e cliente com dia de visita marcado -- a maioria --
// nunca veria a tarja e ficaria sem forma nenhuma de ser inativado, agora que o
// <select> de status saiu do formulario por decisao dela (11/08).
//
// Inativar e reativar sao a PORTA UNICA para mexer no status: elas exigem
// motivo de lista fechada e gravam a data. O formulario nao escreve status.
export function acoesDaFicha(cliente: Cliente): {
  podeInativar: boolean
  podeReativar: boolean
  mostrarSemRota: boolean
} {
  return {
    podeInativar: cliente.status === 'ativo',
    podeReativar: cliente.status === 'inativo',
    mostrarSemRota: semRota(cliente),
  }
}
